// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type UpdateWorkspaceThemeMutationVariables = Types.Exact<{
  input: Types.UpdateWorkspaceThemeInput;
}>;


export type UpdateWorkspaceThemeMutation = { __typename?: 'Mutation', updateWorkspaceTheme: { __typename?: 'Workspace', id: string } };


export const UpdateWorkspaceThemeDocument = gql`
    mutation UpdateWorkspaceTheme($input: UpdateWorkspaceThemeInput!) {
  updateWorkspaceTheme(input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateWorkspaceThemeMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceThemeMutation, { data, loading, error }] = useUpdateWorkspaceThemeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceThemeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWorkspaceThemeMutation, UpdateWorkspaceThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkspaceThemeMutation, UpdateWorkspaceThemeMutationVariables>(UpdateWorkspaceThemeDocument, options);
      }
export type UpdateWorkspaceThemeMutationHookResult = ReturnType<typeof useUpdateWorkspaceThemeMutation>;
export type UpdateWorkspaceThemeMutationResult = ApolloReactCommon.MutationResult<UpdateWorkspaceThemeMutation>;